import { useState } from "react";
// style components
import { notification } from "antd";
// models
import {
  PostulacionModel,
  initialValuesPostulacionModel,
  filtrosPostulacionModel,
  initialFiltrosPostulacionModel,
} from "../models/PostulacionesModel/postulacion.model";
//  api services
import apiParticipantes from "../api/Participantes/api-participantes";
// download files
import fileDownload from "js-file-download";
import DocumentosService from "../api/Documentos/api-documentos";
import apiMaestras from "../api/Maestras/api-maestras";
import { ObjNotificaciones } from "../config/notificaciones";

export const useGestionarPostulaciones = () => {
  const [allPostulacionesSinFiltro, setAllPostulacionesSinFiltro] = useState<any>([]);
  const [allPostulaciones, setAllPostulaciones] = useState<any>([]);
  const [modal, setModal] = useState<boolean>(false);
  const [postulacion, setPostulacion] = useState<PostulacionModel>(initialValuesPostulacionModel);
  const [totalRegistros, setTotalRegistros] = useState<number>(0);
  const [totalRegistrosInscritos, setTotalRegistrosInscritos] = useState<number>(0);
  const [totalRegistrosAnulados, setTotalRegistrosAnulados] = useState<number>(0);
  const [totalregistrosCompletar, setTotalregistrosCompletar] = useState<number>(0);
  const [totalregistrosEvaluado, setTotalregistrosEvaluado] = useState<number>(0);
  const [totalregistrosPorevaluar, setTotalregistrosPorevaluar] = useState<number>(0);
  const [totalregistrosSubsanado, setTotalregistrosSubsanado] = useState<number>(0);
  const [totalregistrosSubsanar, setTotalregistrosSubsanar] = useState<number>(0);
  const [totalregistrosAceptado, setTotalregistrosAceptado] = useState<number>(0);
  const [totalregistrosRechazado, setTotalregistrosRechazado] = useState<number>(0);
  const [totalregistrosBeneficiarios, setTotalregistrosBeneficiarios] = useState<number>(0);
  const [cantidadPáginas, setCantidadPáginas] = useState<number>(10);
  const [categorias, setCategorias] = useState<any>([]);
  const [lineasConvocatorias, setLineasConvocatorias] = useState<any>([]);
  const [filtros, setFiltros] = useState<filtrosPostulacionModel>(initialFiltrosPostulacionModel);
  const [loading, setLoading] = useState(false);

  const cargarTodasPostulaciones = async (isBeps?: boolean, tipoPostulacion?: string) => {
    let { data: postulaciones } = await apiParticipantes.consultarPostulacionesEnPorcesoArtistas();

    let postulacionesMap = postulaciones.map((x: any, idx: any) => {
      return {
        ...x,
        index: idx + 1
      }
    })

    let postulacionesfiltro = postulacionesMap.filter((x: any) => x.tipo === 1);

    if (isBeps) {
      postulacionesfiltro = postulacionesMap.filter((x: any) => x.tipo === 3);
    }

    if (tipoPostulacion === 'general') {
      postulacionesfiltro = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === "Rechazado" || x.estado === "Aceptado" || x.estado === "Subsanar" || x.estado === "Subsanado" || x.estado === "Inscrito sin revisar" || x.estado === "Sin revisar" || x.estado === "Por evaluar" || x.estado === "Anulado" || x.estado === "Beneficiario" || x.estado === "Por completar" || x.estado === "Evaluado"));
    }

    let inscritos = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === 'Inscrito sin revisar' || x.estado === "Sin revisar"))
    let anulados = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === 'Anulado'))
    let completar = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === 'Por completar'))
    let porEvaluar = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === 'Por evaluar'))
    let evaluado = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === 'Evaluado'))
    let subsanado = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === 'Subsanado'))
    let subsanar = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === 'Subsanar'))
    let aceptado = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === 'Aceptado'))
    let rechazado = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === 'Rechazado'))
    let beneficiarios = postulacionesMap.filter((x: any) => x.links !== null && (x.estado === 'Beneficiario'))
    setTotalregistrosRechazado(rechazado.length)
    setTotalregistrosAceptado(aceptado.length)
    setTotalregistrosSubsanar(subsanar.length)
    setTotalregistrosPorevaluar(porEvaluar.length)
    setTotalregistrosSubsanado(subsanado.length)
    setTotalregistrosEvaluado(evaluado.length)
    setTotalregistrosCompletar(completar.length)
    setTotalRegistrosAnulados(anulados.length)
    setTotalRegistrosInscritos(inscritos.length)
    setTotalregistrosBeneficiarios(beneficiarios.length)
    setTotalRegistros(postulacionesfiltro.length);
    setAllPostulacionesSinFiltro(postulacionesfiltro);
    setAllPostulaciones(postulacionesfiltro);

    // Se devuelven ademas de guardarse: quien exporta las necesita en el
    // momento y no puede esperar a que el estado se actualice.
    return postulacionesfiltro;
  };

  const VerPropuesta = (datos: any) => {
    console.log(datos);
    setPostulacion(datos);
    return setModal(true);
  };

  const AceptarModalPropuesta = async (observaciones?: any, countSubsanable?: any, setObservaciones?: any) => {
    if (observaciones !== null && observaciones.length > 0) {
      await apiParticipantes.actualizarObservacion(postulacion.id_postulacion, observaciones);
      setObservaciones(null);
    } else {
      return ObjNotificaciones.MSG_ERROR('warning', '¡Ingresa las observaciones!', 'Debes indicar las observaciones cuando solicitas la subsanación de algún documento')
    }

    await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
      postulacion.id_postulacion,
      postulacion.documentos_administrativos
    );

    await apiParticipantes.guardarDocumentosTecnicosPostulacion(
      postulacion.id_postulacion,
      postulacion.documentos_tecnicos
    );
    let estado = "Aceptado";
    let documentosadminaceptar = [];
    let documentosadminrechazar = [];
    let documentosadminsubsanar = [];
    let documentostecnaceptar = [];
    let documentostecnicosrechazados = [];

    if (postulacion.documentos_administrativos) {
      documentosadminrechazar = postulacion.documentos_administrativos.map((x: any) => x.checkcancelar);
      documentosadminsubsanar = postulacion.documentos_administrativos.map((x: any) => x.checksubsanable);
      documentostecnicosrechazados = postulacion.documentos_tecnicos.map((x: any) => x.checkaceptartecnico);
    }

    let rechazada = documentosadminrechazar.filter((data: any) => data === true);
    let subsanar = documentosadminsubsanar.filter((data: any) => data === true);
    let doctecnicos = documentostecnicosrechazados.filter((data: any) => data === false);

    if (subsanar.length > 0) estado = "Subsanar";
    if (rechazada.length > 0) estado = "Rechazado";
    if (doctecnicos.length > 0) estado = "Rechazado";

    await apiParticipantes.cambiarEstadoPostulacion({ id_postulacion: postulacion.id_postulacion, estado: estado });

    openNotification({
      titulo: "Finalizado correctamente",
      descripcion: "Se han actualizado el estado de los documentos",
      placement: "bottomRight",
    });

    buscarpostulaciones()
    return setModal(false);
  };
  // notification
  const openNotification = ({ titulo, descripcion, placement }: any) => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };
  const CancelarModal = () => {
    return setModal(false);
  };
  const descargarArchivo = async (url: string) => {
    try {
      let data: any = await DocumentosService.consultarArchivo(url);
      fileDownload(data, url);
    } catch (error) {
      console.log(error)
    }
  };
  const cambiarCantidadPaginas = (e: any, value: any) => {
    setCantidadPáginas(value);
  };

  const obtenerLineasConvocatorias = async () => {
    let data = await apiMaestras.obtenerLineaConvocatoria();
    return setLineasConvocatorias(data);
  }

  const obtenerCategoriasLineas = async () => {
    let data = await apiMaestras.obtenerCategorias();

    return setCategorias(data);
  };
  const limpiarFiltros = () => {
    setTotalRegistrosInscritos(0);
    setTotalRegistrosAnulados(0);
    setTotalregistrosCompletar(0);
    setTotalregistrosPorevaluar(0);
    setTotalregistrosEvaluado(0);
    setTotalregistrosSubsanado(0);
    setTotalregistrosSubsanar(0);
    setTotalregistrosAceptado(0);
    setTotalregistrosRechazado(0);
    setTotalRegistros(0);
    setFiltros(initialFiltrosPostulacionModel)
    return setAllPostulaciones(allPostulacionesSinFiltro);
  };


  const buscarpostulaciones = async () => {
    setLoading(true)
    try {
      let filtro = allPostulacionesSinFiltro;

      // Buscar por palabra clave
      if (filtros.buscarpalabra && filtros.buscarpalabra !== "") {
        filtro = await buscarPorPalabra(filtros.buscarpalabra);
        console.log(filtro)
        return procesarResultados(filtro);
      }

      // Buscar por línea estratégica
      if (filtros.linea_estrategica && filtros.linea_estrategica !== "") {
        filtro = await buscarPorLinea(filtros.linea_estrategica);
      }

      // Filtrar por categoría si aplica
      if (filtros.categoria && filtros.categoria !== "") {
        filtro = filtrarPorCategoria(filtro, filtros.categoria);
      }

      return procesarResultados(filtro);
    } catch (error) {
      console.error("Error en la búsqueda de postulaciones", error);
    }
  };

  const buscarPorPalabra = async (palabra) => {
    let resultado;
    if (/^\d+$/.test(palabra)) {
      resultado = await apiParticipantes.consultarPostulacionesById(palabra);
    } else {
      resultado = await apiParticipantes.consultarPostulacionesByCodigo(palabra.toUpperCase());
    }
    // Asegurar que siempre sea un array
    return resultado.data.filter((x: any) => x.links !== null && (x.estado === "Rechazado" || x.estado === "Aceptado" || x.estado === "Subsanar" || x.estado === "Subsanado" || x.estado === "Inscrito sin revisar" || x.estado === "Sin revisar" || x.estado === "Por evaluar" || x.estado === "Anulado" || x.estado === "Beneficiario" || x.estado === "Por completar" || x.estado === "Evaluado"))
  };

  const buscarPorLinea = async (idLinea) => {
    let { data } = await apiParticipantes.obtenerPostulacionesByLinea(idLinea);
    return data[0].filter((x) => x.links !== null && estadosValidos.includes(x.estado));
  };

  const filtrarPorCategoria = (filtro, categoria) => {
    return filtro.filter(
      (x) => x.categoria_linea_convocatoria && x.categoria_linea_convocatoria === categoria
    );
  };

  const procesarResultados = (filtro) => {
    const clasificaciones = agruparPorEstado(filtro);
    actualizarContadores(clasificaciones);
    setTotalRegistros(filtro.length);
    setLoading(false)
    return setAllPostulaciones(filtro);
  };

  const agruparPorEstado = (filtro) => {
    return {
      inscritos: filtro.filter((x) => x.estado === "Inscrito sin revisar" || x.estado === "Sin revisar"),
      anulados: filtro.filter((x) => x.estado === "Anulado"),
      completar: filtro.filter((x) => x.estado === "Por completar"),
      porEvaluar: filtro.filter((x) => x.estado === "Por evaluar"),
      evaluado: filtro.filter((x) => x.estado === "Evaluado"),
      subsanado: filtro.filter((x) => x.estado === "Subsanado"),
      subsanar: filtro.filter((x) => x.estado === "Subsanar"),
      aceptado: filtro.filter((x) => x.estado === "Aceptado"),
      rechazado: filtro.filter((x) => x.estado === "Rechazado"),
      beneficiarios: filtro.filter((x) => x.estado === "Beneficiario"),
    };
  };

  const actualizarContadores = (clasificaciones) => {
    setTotalRegistrosInscritos(clasificaciones.inscritos.length);
    setTotalRegistrosAnulados(clasificaciones.anulados.length);
    setTotalregistrosCompletar(clasificaciones.completar.length);
    setTotalregistrosPorevaluar(clasificaciones.porEvaluar.length);
    setTotalregistrosEvaluado(clasificaciones.evaluado.length);
    setTotalregistrosSubsanado(clasificaciones.subsanado.length);
    setTotalregistrosSubsanar(clasificaciones.subsanar.length);
    setTotalregistrosAceptado(clasificaciones.aceptado.length);
    setTotalregistrosRechazado(clasificaciones.rechazado.length);
    setTotalregistrosBeneficiarios(clasificaciones.beneficiarios.length);
  };

  const estadosValidos = [
    "Rechazado", "Aceptado", "Subsanar", "Subsanado", "Inscrito sin revisar",
    "Sin revisar", "Por evaluar", "Anulado", "Beneficiario", "Por completar",
    "Evaluado"
  ];

  return {
    allpostulaciones: allPostulaciones,
    setAllPostulaciones,
    cargarTodasPostulaciones,
    modal,
    VerPropuesta,
    AceptarModalPropuesta,
    CancelarModal,
    descargarArchivo,
    postulacion,
    totalregistros: totalRegistros,
    cantidadpáginas: cantidadPáginas,
    cambiarCantidadPaginas,
    categorias,
    lineasconvocatoria: lineasConvocatorias,
    obtenerCategoriasLineas,
    obtenerLineasConvocatorias,
    filtros,
    setFiltros,
    limpiarFiltros,
    buscarpostulaciones,
    totalregistrosInscritos: totalRegistrosInscritos,
    totalregistrosAnulados: totalRegistrosAnulados,
    totalregistrosCompletar,
    totalregistrosEvaluado,
    totalregistrosPorevaluar,
    totalregistrosSubsanado,
    totalregistrosSubsanar,
    totalregistrosAceptado,
    totalregistrosRechazado,
    totalregistrosBeneficiarios,
    loading
  };
};
